
import { useCallback } from 'react';
import { Exercise } from '@/models/LearnTypes';

interface UseAnswerCheckerProps {
  currentExercise: Exercise | undefined;
  setShowAnswer: React.Dispatch<React.SetStateAction<boolean>>;
  handleCheckSpellingAnswer: () => boolean;
}

/**
 * Hook to handle checking answers for different exercise types
 */
export const useAnswerChecker = ({
  currentExercise,
  setShowAnswer,
  handleCheckSpellingAnswer
}: UseAnswerCheckerProps) => {
  
  // Check the answer for the current exercise
  const handleCheckAnswer = useCallback(() => {
    if (!currentExercise) {
      console.warn('❓ [handleCheckAnswer] No current exercise to check');
      return false;
    }
    
    console.log(`❓ [handleCheckAnswer] Checking answer for ${currentExercise.word} (${currentExercise.type})`);
    
    // For spelling exercises, use the specialized handler
    if (currentExercise.type === 'spelling') {
      console.log(`❓ [handleCheckAnswer] Using spelling answer checker`);
      return handleCheckSpellingAnswer();
    } else {
      // For other exercise types, just show the answer
      console.log(`❓ [handleCheckAnswer] Non-spelling exercise, just showing answer`);
      setShowAnswer(true);
      return false;
    }
  }, [currentExercise, handleCheckSpellingAnswer, setShowAnswer]);
  
  return {
    handleCheckAnswer
  };
};
